export default "<h2>Ошибка 404 &ndash; Страница не найдена</h2>"